<template>
  <v-card outlined height="100%">
    <v-card-actions class="py-0">
      <v-toolbar dense flat>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="saveGruppen()">Speichern</v-btn>
      </v-toolbar>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <!-- Diese Zeile wieder hinzufügen, wenn auch die Reihenfolge der Ordner vertauscht werden soll. -->
            <!-- <draggable class="row no-gutters" v-model="gruppen.gruppen" @change="saveGruppen()"> -->
              <v-row no-gutters>
              <v-col cols="12" v-for="(gruppe, index) in gruppen.gruppen" :key="index" class="px-1">
                <v-card outlined>
                  <v-card-title>
                    <!-- <v-icon>drag_indicator</v-icon> -->
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="gruppe.titel"
                      :label="index + 1 + '. Ordner'"
                    ></v-text-field>
                  </v-card-title>
                  <v-expansion-panels class="elevation-0 pa-6 pt-0">
                    <draggable class="v-item-group theme--light v-expansion-panels" v-model="gruppe.gruppen" @change="saveGruppen()" group="myGroup">
                      <v-expansion-panel v-for="(item, index2) in gruppe.gruppen" :key="index2">
                        <v-expansion-panel-header expand-icon="edit" disable-icon-rotate class="py-0 pl-0">
                          <!-- {{ item.text }} -->
                          <v-list class="pa-0" dense>
                            <v-list-item class="pa-0">
                              <v-list-item-avatar class="my-0">
                                <v-icon>drag_indicator</v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content class="py-0">
                                <v-list-item-title v-html="item.text"></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-0 ma-0">
                          <v-card outlined class="py-2 px-1">
                            <v-text-field class="mx-1" outlined dense hide-details label="Gruppenname" v-model="item.text"></v-text-field>
                            <v-row no-gutters v-for="(bedingung, key, index) in item.bedingungen" :key="index" class="px-0 mx-0 py-2">
                              <v-col cols="12" class="px-1 mt-2">
                                <v-autocomplete hide-details dense outlined v-model="bedingung.feld" :items="kontaktfelder_system" label="Kontaktfeld"></v-autocomplete> {{ item.bedingungen.status }}
                              </v-col>
                              <v-col cols="12" class="px-1 mb-2 mt-2">
                                <!-- <v-text-field hide-details dense outlined v-model="bedingung.wert" label="Werte (durch Komma getrennt)" append-outer-icon="close" @click:append-outer="deleteBedingung(item, bedingung)"></v-text-field> -->
                                <v-combobox chips clearable deletable-chips multiple hide-details dense outlined v-model="bedingung.wert" label="Werte" append-outer-icon="close" @click:append-outer="deleteBedingung(item, bedingung)"></v-combobox>
                              </v-col>
                            </v-row>
                            <v-btn block outlined @click="addBedingung(item)"><v-icon>add</v-icon></v-btn>
                            <v-btn block outlined @click="deleteGruppe(index, item)">Gruppe löschen<v-icon>delete</v-icon></v-btn>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </draggable>
                  </v-expansion-panels>
                  <v-divider></v-divider>
                  <v-btn block text @click="addGruppe(index)"><v-icon>add</v-icon>Gruppe</v-btn>
                </v-card>
              </v-col>
            </v-row>
            <!-- </draggable> -->
      
    </v-card-text>
  </v-card>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    data () {
      return {
        search: ''
      }
    },
    components: {
      draggable
    },
    computed: {
      gruppen () {
        return this.$store.getters['einstellungen/einstellung']('gruppen')
      },
      kontaktfelder_system () {
        let items = []
        this.$store.getters['einstellungen/einstellung']('kontaktfelder').neuFelder.forEach(item => {
          items.push({
            text: item.label,
            value: item.value
          })
        })
        return items
      }
    },
    methods: {
      saveGruppen () {
        this.$store.dispatch('einstellungen/updateEinstellungData', this.gruppen)
      },
      addBedingung (item) {
        item.bedingungen.push({
          feld: '',
          wert: []
        })
      },
      deleteBedingung (item, bedingung) {
        item.bedingungen.splice(item.bedingungen.indexOf(bedingung), 1)
      },
      addGruppe (index) {
        this.gruppen.gruppen[index].gruppen.push({
          bedingungen: [],
          text: 'Neue Gruppe'
        })
      },
      deleteGruppe (index, item) {
        this.gruppen.gruppen[index].gruppen.splice(this.gruppen.gruppen[index].gruppen.indexOf(item), 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Gruppen.vue?215b9c8a